import { PageDoesntExist } from "@/pageDoesntExist";
import { siteRoutes } from "../siteRoutesList";
import QuickAccountCredentials from "@/features/auth/components/QuickAccountCredentials/QuickAccountCredentials";

export const authRoutes = [
  // AUTH AFTER SIGN UP
  {
    element: PageDoesntExist,
    path: "/signincallback/",
  },
  {
    element: QuickAccountCredentials,
    path: siteRoutes["accountSetup"],
  },
];
